<template>
  <div class="container">
    <h3>Clientes</h3>
    <Table :showFilter="true" />
  </div>
</template>

<script>
import Table from "@/views/clients/table.vue";
export default {
  name: "Products",
  components: {
    Table,
  },
};
</script>
